import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { useHistory } from "react-router-dom";

import api from "../../services/api";
import { notify } from "../../utils/notify";
import MaskService from "../../utils/mask/maskService";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import { GlobalVariables } from "../../global";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import SelectCustom from "../../components/basic/SelectCustom";
import "./.promoter.css";
import {
  handleAddressInfosByBigData,
  handleDocumentInfosByBigData,
} from "../../services/infosByBigData";

const CreatePromoter = () => {
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [inputSelect, setInputSelect] = useState({ CNPJ: true, CPF: false });
  const [reason, setReason] = useState("");
  const [fantasy, setFantasy] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [cnpjMatriz, setCnpjMatriz] = useState("");
  const [ie, setIe] = useState("");
  const [im, setIm] = useState("");
  const [cep, setCep] = useState("");
  const [uf, setUf] = useState("");
  const [county, setCounty] = useState("");
  const [address, setAddress] = useState("");
  const [number, setNumber] = useState("");
  const [district, setDistrict] = useState("");
  const [complement, setComplement] = useState("");
  const [telephone, setTelephone] = useState("");
  const [crc, setCrc] = useState("");
  const [disableCRC, setDisableCRC] = useState(true);
  const [typePromoter, setTypePromoter] = useState(null);
  const [optionsTypePromoters, setOptionsTypePromoters] = useState([
    { Id: 0, Nome: "" },
  ]);
  const [active, setActive] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const getDataByCNPJ = async () => {
      try {
        const cnpjRemoveMask = cnpj;
        const typeDocument = inputSelect.CNPJ ? "cnpj" : "cpf";

        if (typeDocument === "cpf" && !birthDate) return;
        setLoading(true);

        const { data: promoterExist } = await api.get(
          `/promotor/${cnpjRemoveMask.replace(/[^0-9]+/g, "")}/existe`
        );

        if (promoterExist && promoterExist.data) {
          notify("Este documento já está cadastrado como promotor.");
          return setLoading(false);
        }

        const documentTypeProps = {
          cnpj: {
            setters: {
              setTelephone,
              setReason,
              setNumber,
              setState: setUf,
              setAddress,
              setCity: setCounty,
              setDistrict,
              setCep,
            },
          },
          cpf: {
            setReason,
            setFantasy,
          },
        };

        await handleDocumentInfosByBigData({
          type: typeDocument,
          document: cnpj,
          birthDate: birthDate || null,
          setters: documentTypeProps[typeDocument].setters,
        });

        setLoading(false);
      } catch (error) {
        setLoading(false);

        notify("Não foi possível encontrar dados do CNPJ/CPF informado.");
      }
    };

    if (
      (inputSelect.CNPJ && cnpj.length === 18) ||
      (inputSelect.CPF && cnpj.length === 14)
    ) {
      getDataByCNPJ();
    }
  }, [cnpj, inputSelect]);

  useEffect(() => {
    const getDataByCEP = async () => {
      setLoading(true);
      try {
        await handleAddressInfosByBigData({
          postalCode: cep.replace(/[^0-9]+/g, ""),
          setDistrict,
          setCounty,
          setAddress,
          setUf,
        });

        setLoading(false);
      } catch (error) {
        setLoading(false);

        notify("Não foi possível encontrar dados do CNPJ/CPF informado.");
      }
    };

    if (cep && cep.length === 10 && !district) {
      getDataByCEP();
    }
  }, [cep, district]);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);

        const { data: result } = await api.get(
          "promotor/dadosParaCriarPromotor"
        );

        const data = result.data;

        data.typePromoters.unshift({ Id: 0, Nome: "" });

        setOptionsTypePromoters(data.typePromoters);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getData();
  }, []);

  const handleBirthDate = async (e) => {
    setBirthDate(e.target.value);
    if (!e.target.value || e.target.valueAsDate.getFullYear() < 1900 || !cnpj) {
      return;
    }
    setLoading(true);
    await handleDocumentInfosByBigData({
      type: "cpf",
      document: cnpj.replace(/[^0-9]+/g, ""),
      birthDate: e.target.valueAsDate.toISOString().split("T")[0],
      setters: {
        setReason,
        setFantasy,
      },
    });
    setLoading(false);
  };

  const alterCnpjCpf = (value) => {
    setInputSelect(value);
    setCnpjMatriz("");
    setActive(false);
    setCnpj("");
    setIe("");
    setIm("");
    setFantasy("");
    setReason("");
    setCep("");
    setCounty("");
    setUf("");
    setAddress("");
    setNumber("");
    setDistrict("");
    setComplement("");
    setTelephone("");
    setBirthDate("");
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      let validationFail = false;

      const requiredInputs = [
        { value: cnpj, key: "cnpj" },
        { value: reason, key: "reason" },
        { value: fantasy, key: "fantasy" },
        { value: typePromoter, key: "typePromoter" },
        { value: cep, key: "cep" },
        { value: uf, key: "uf" },
        { value: county, key: "county" },
        { value: address, key: "address" },
        { value: number, key: "number" },
        { value: district, key: "district" },
        { value: telephone, key: "telephone" },
      ];

      if (active) {
        requiredInputs.push({ value: cnpjMatriz, key: "cnpjMatriz" });
      }

      const resultValidation = validatesNotNull(requiredInputs);

      if (cnpj.length > 14 && !MaskService.isValid("cnpj", cnpj)) {
        validationFail = true;
        resultValidation.errorsValidation.cnpj = true;
        notify("O CNPJ informado é inválido.", true, "error");
      }

      if (cnpj.length <= 14 && !MaskService.isValid("cpf", cnpj)) {
        validationFail = true;
        resultValidation.errorsValidation.cnpj = true;
        notify("O CPF informado é inválido.", true, "error");
      }

      if (cep && !MaskService.isValid("cep", cep)) {
        validationFail = true;
        resultValidation.errorsValidation.cep = true;
        notify("O CEP informado é inválido.", true, "error");
      }

      if (telephone && !MaskService.isValid("cel-phone", telephone)) {
        validationFail = true;
        resultValidation.errorsValidation.telephone = true;
        notify("O telefone informado é inválido.", true, "error");
      }

      if (active && cnpjMatriz && !MaskService.isValid("cnpj", cnpjMatriz)) {
        validationFail = true;
        resultValidation.errorsValidation.cnpjMatriz = true;
        notify("O CNPJ da matriz informado é inválido.", true, "error");
      }

      if (resultValidation.error || validationFail) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      } else {
        setErrors({});
      }

      const body = {
        CNPJ: cnpj,
        Fantasia: fantasy.substr(0, 60),
        Razao: reason.substr(0, 90),
        IE: ie,
        IM: im,
        CEP: cep,
        Municipio: county.substr(0, 50),
        UF: uf.substr(0, 2),
        Endereco: address.substr(0, 50),
        Numero: number.substr(0, 50),
        Bairro: district.substr(0, 50),
        Complemento: complement.substr(0, 50),
        Telefone: telephone,
        CRC: crc.substr(0, 50),
        MatrizCNPJ: active ? cnpjMatriz : null,
        IdTipoPromotor: typePromoter.Id,
        IdStatus: GlobalVariables.ID_STATUS_ATIVO,
      };

      const { data } = await api.post("promotor", body);

      setLoading(false);

      if (data.success) {
        notify("Promotor criado com sucesso.", true, "info");
        goBack();
      }
    } catch (error) {
      console.error("ERROR: CreatePromoter", error);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="flex-start"
          item
          lg={9}
          md={10}
          sm={10}
          xs={11}
          id="formContent"
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            container
            alignItems="center"
            justify="center"
          >
            <ArrowBackIcon className="iconGoBack" onClick={goBack} />
            <label className="title">Novo promotor</label>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ButtonGroup
              style={{
                alignItems: "flex-start",
                display: "flex",
              }}
              color="primary"
              aria-label="outlined secondary button group"
            >
              <Button
                className={inputSelect.CNPJ ? "buttonOn" : "buttonOff"}
                onClick={() => {
                  if (!inputSelect.CNPJ) {
                    alterCnpjCpf({ CNPJ: true, CPF: false });
                  }
                }}
              >
                CNPJ
              </Button>
              <Button
                className={inputSelect.CPF ? "buttonOn" : "buttonOff"}
                onClick={() => {
                  if (!inputSelect.CPF) {
                    alterCnpjCpf({ CNPJ: false, CPF: true });
                  }
                }}
              >
                CPF
              </Button>
            </ButtonGroup>
          </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <TextFieldCustom
              label={inputSelect.CNPJ ? "CNPJ*" : "CPF*"}
              autoFocus
              type="text"
              value={cnpj}
              setValue={setCnpj}
              mask={inputSelect.CNPJ ? "cnpj" : "cpf"}
              error={errors.cnpj}
            />
          </Grid>

          {inputSelect.CPF && (
            <Grid item lg={2} md={4} sm={12} xs={12}>
              <TextFieldCustom
                label={"Data de nascimento"}
                type="date"
                value={birthDate}
                onChange={handleBirthDate}
                mask={"date"}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          )}

          <Grid item lg={inputSelect.CPF ? 2 : 4} md={4} sm={6} xs={6}>
            <TextFieldCustom
              maxLength={50}
              label="IE"
              type="text"
              value={ie}
              setValue={setIe}
              error={errors.ie}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={6}>
            <TextFieldCustom
              maxLength={50}
              label="IM"
              type="text"
              value={im}
              setValue={setIm}
              error={errors.im}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={120}
              label="Fantasia*"
              type="text"
              value={fantasy}
              setValue={setFantasy}
              error={errors.fantasy}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={120}
              label="Razão*"
              type="text"
              value={reason}
              setValue={setReason}
              error={errors.reason}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={12}>
            <TextFieldCustom
              label="CEP*"
              type="text"
              mask="cep"
              value={cep}
              setValue={setCep}
              error={errors.cep}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Município*"
              type="text"
              value={county}
              setValue={setCounty}
              error={errors.county}
            />
          </Grid>

          <Grid item lg={2} md={2} sm={2} xs={12}>
            <TextFieldCustom
              label="UF*"
              type="text"
              value={uf}
              onChange={(e) => {
                if (e.target.value.length < 3) {
                  setUf(e.target.value.toString().toUpperCase());
                }
              }}
              error={errors.uf}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Endereço*"
              type="text"
              value={address}
              setValue={setAddress}
              error={errors.address}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Número*"
              type="text"
              value={number}
              setValue={setNumber}
              error={errors.number}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Bairro*"
              type="text"
              value={district}
              setValue={setDistrict}
              error={errors.district}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Complemento"
              type="text"
              value={complement}
              setValue={setComplement}
              error={errors.complement}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <TextFieldCustom
              label="Telefone*"
              type="text"
              value={telephone}
              mask="cel-phone"
              setValue={setTelephone}
              error={errors.telephone}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <SelectCustom
              label="Tipo de promotor*"
              keyObject="Nome"
              value={typePromoter}
              onChange={(value) => {
                setTypePromoter(value);
                if (
                  value.Id === parseInt(GlobalVariables.TIPO_PROMOTOR_CONTADOR)
                ) {
                  setDisableCRC(false);
                } else {
                  setDisableCRC(true);
                  setCrc("");
                }
              }}
              error={errors.typePromoter}
              optionsList={optionsTypePromoters}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={12}>
            <TextFieldCustom
              disabled={disableCRC}
              maxLength={50}
              label="CRC"
              type="text"
              value={crc}
              setValue={setCrc}
              error={errors.crc}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={active}
                  onChange={() => {
                    setCnpjMatriz("");
                    setActive(!active);
                  }}
                  name="checkedB"
                  className="checkboxColor"
                />
              }
              label="Vincular matriz"
            />
          </Grid>

          {active && (
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <TextFieldCustom
                label="CNPJ Matriz*"
                type="text"
                value={cnpjMatriz}
                mask="cnpj"
                setValue={setCnpjMatriz}
                error={errors.cnpjMatriz}
              />
            </Grid>
          )}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <button
              id="buttonStylePromocode"
              type="submit"
              className="btn btn-info"
            >
              Salvar
            </button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};
export default CreatePromoter;
